import React from "react";
import { Redirect, Link } from 'react-router-dom';
import ReCAPTCHA from "react-google-recaptcha";
import { ElementsConsumer, CardElement } from "@stripe/react-stripe-js";
import Axios from 'axios';
import { API_URL, TEST_SITE_KEY } from '../config/constants.js';
import InputMask from 'react-input-mask';
import DOMPurify from "dompurify";
import defaultimg from './no-photo-available.jpg';
import $ from 'jquery';
import ls from 'local-storage';
import { Spinner } from 'react-bootstrap';
import CropAndPreview from '../includes/CropAndPreviewModal.component';
//import isStrongPassword from 'validator/lib/isStrongPassword';

import DatePicker from 'react-datepicker'; 
import "react-datepicker/dist/react-datepicker.css";
import moment from 'moment';
import { addDays, subDays } from 'date-fns';


const base_api_url = API_URL;
const axiosConfig = {
	'Content-Type': 'multipart/form-data',
	"Access-Control-Allow-Origin": "*",
}
const DELAY = 1500;
const errors = {};
class CheckoutForm extends React.Component {

	constructor(props) {
		super(props);

		this.state = {
	      dob: new Date()
	    };
		this._reCaptchaRef = React.createRef();
		
	    this.handleChange = this.handleChange.bind(this);

		this.onChangeFirstName = this.onChangeFirstName.bind(this);
		this.termCondition = this.termCondition.bind(this);
		this.onChangeLastName = this.onChangeLastName.bind(this);
		this.onChangeEmail = this.onChangeEmail.bind(this);
		this.onChangeArtPassword = this.onChangeArtPassword.bind(this);
		this.onChangeDob = this.onChangeDob.bind(this);
		this.onChangeGender = this.onChangeGender.bind(this);
		this.onChangeAddress = this.onChangeAddress.bind(this);
		this.onChangeCellphone = this.onChangeCellphone.bind(this);
		this.onChangeCity = this.onChangeCity.bind(this);
		this.onChangeStates = this.onChangeStates.bind(this);
		this.onChangeZipcode = this.onChangeZipcode.bind(this);
		this.onChangeSubscription = this.onChangeSubscription.bind(this);
		this.onChangeSSN = this.onChangeSSN.bind(this);
		this.onFileChange = this.onFileChange.bind(this);
		this.onChangeCountry = this.onChangeCountry.bind(this);
		this.handleRecaptchaChange 	= this.handleRecaptchaChange.bind(this);			
		this.asyncScriptOnLoad		= this.asyncScriptOnLoad.bind(this);
		
		var today = new Date();
		var date = '';
		var year  = today.getFullYear();
		var month = today.getMonth() + 1;
		var todaydate = today.getDate();
		if(month<10){
			var month = '0'+month;
		}
		
		if(todaydate<10){
			var todaydate = '0'+todaydate;
		}
		date = year + '-' + month + '-' + todaydate;
		
		this.state = {
			isVerified: false,
			first_name: '',
			last_name: '',
			email: '',
			artpassword: '',
			dob: '',
			ssn: '',
			gender: '',
			address: '',
			cellphone: '',
			country:'',
			city: '',
			states: '',
			zipcode: '',
			planid: '',
			error: null,
			msg: null,
			emailmsg: null,
			loader: null,
			payment: false,
			planlist:[],
			countrylist:[],
			usertype: null,
			maxdate: date,
			successclass: 'hideclass',
			redirect: false,
			submitbuttontext: 'Submit',
			enablesubmitbutton: false,
			disablebtn: true,
			wrongpassmsg:'',
			callback: "not fired",
			value: "[empty]",
			load: false,
			expired: false,
			btndisable: false,
			cnlbtndisable: true,
			radioReading: true,
			radioPlan: false,
			errors:[],
			term: false,
			//captcha: false,
			captcha: true,
			gender:'male',
			emailExist:false,
			formValidation: true,
			formReferral: true,
			showCropAndPreview: false,
			selectedFile: '',
			ref_code:'',
			profile_pic_path: '',
			readOnly: 'false',
			label: 'Celebrity/Church Name'
		}

		
	}
	handleShow = () => {
		this.setState({ showCropAndPreview: !this.state.showCropAndPreview });
	};
	handleChange(date) {
		if(this.state.errors['error_dob']){delete this.state.errors['error_dob'];}
		this.setState({
		  dob: date
		})
	}
	componentDidMount(){
		if(this.props.type == 'listener'){
			var utype = 'listener';
			var role = '1';
		}
		if(this.props.type == 'artist'){
			var utype = 'artist';
			var role = '2';
		}
		this.setState({role : role});
		this.getplandetails(utype);	
		this.getcountrylist();	
		setTimeout(() => {
			this.setState({ load: true });
		}, DELAY);
		if(this.props.ref_code){
			this.checkReferralCode(this.props.ref_code);
			this.setState({
				ref_code: this.props.ref_code,
				readOnly: 'true'
			})
		}
		
	}
	checkReferralCode = (ref_code) => {
		if(ref_code){
			const obj = {
				code: ref_code
			}
			Axios.post(base_api_url + 'check-referral-code.php', obj)
			.then(
				(res) => {
					if (res.data.res_status) {
						this.setState({
							formReferral: true,
							successclass: '',
							msg: '',
							code_type: res.data.referral_type,
							label: res.data.label,
							cel_church_name: res.data.cel_church_name
						});
						if(res.data.referral_type === 'celebrity'){
							this.setState({
								celebrityRadio:true,
								churchRadio:false,
								disabled:true
							});
						}else{
							this.setState({
								celebrityRadio:false,
								churchRadio:true,
								disabled:true
							});
						}
					} else {
						this.setState({
							successclass: 'errormsg',
							msg: res.data.res_message,
							error_msg: res.data.res_message,
							formReferral: false,
							disabled:false,
							celebrityRadio:false,
							churchRadio:false,
							cel_church_name: '',
							label: 'Celebrity/Church Name'
						})
					}
				}
			);
		}		
	}
	changeReferralCode(e){
		this.setState({
			error_msg: '',
			ref_code: e.target.value,
			formReferral: true,
			successclass: '',
			msg: '',
		});
	}
	onChangeCodeType(e) {		
		let code_type = e.target.value;
		if(code_type === 'celebrity'){
			this.setState({
				celebrityRadio:true,
				churchRadio:false
			});
		}else{
			this.setState({
				celebrityRadio:false,
				churchRadio:true
			});
		}	
		this.setState({
			code_type: e.target.value
		});
	}
	getcountrylist = () => {
		Axios.post(base_api_url + 'country.php')
			.then(
				(res) => {
					if (res.data.res_status == 200) {
						this.setState({
							countrylist: res.data.res_data
						});
					} else {
						this.setState({
							countrylist: []
						});
					}
				}
			);
	}


	getplandetails = (utype) => {
		
		const usertype = utype;
		const obj = {
			usertype: usertype
		}

		Axios.post(base_api_url + 'getplandetails.php', obj)
			.then(
				(res) => {
					if (res.data.res_status == 200) {
						this.setState({
							planlist: res.data.res_data,
							usertype: usertype
						});
					} else {
						this.setState({
							planlist: [],
							usertype: usertype
						});
					}
				}
			);
	}

	state = {
		selectedFile: ''
	};

	onFileChange(e) {
		// this.setState({ selectedFile: e.target.files[0] });
		if (this.state.errors['image_error']) {
		  delete this.state.errors['image_error'];
		}
		if(e.target.files.length>0){
			let url = URL.createObjectURL(e.target.files[0]);
			this.setState({ selectedprofile: e.target.files[0].name, selectedFile: url, showCropAndPreview: true });
		}else{
			this.setState({ selectedprofile: null, selectedFile: null, showCropAndPreview: false });
		}
	};

	onChangeFirstName(e) {
		if(this.state.errors['error_first_name']){delete this.state.errors['error_first_name'];}
		this.setState({
			first_name: e.target.value
		});		
	}

	onChangeLastName(e) {
		this.setState({
			last_name: e.target.value
		})
	}
	termCondition(e){
		if(this.state.errors['error_term']){delete this.state.errors['error_term'];}
		this.setState({
			term: !this.state.term
		});
	}
	onChangeEmail(e) {
		if(this.state.errors['email']){delete this.state.errors['email'];}
		this.setState({
			email: e.target.value,
			emailmsg: null
		});

		const obj = {
			email: e.target.value
		}

		Axios.post(base_api_url + 'email_exist.php', obj)
			.then(
				(res) => {
					if (res.data.res_status == 200) {
						this.setState({
							emailmsg: 'Email already exist.',
							btndisable:false,
							emailExist:true
						});
					} else {
						this.setState({
							emailmsg: null,
							btndisable:true,
							emailExist:false
						});
					}
				}
			);
	}
	validateEmail(email) {
	    const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
	    return re.test(String(email).toLowerCase());
	}
	onChangeArtPassword(e) {
		if(this.state.errors['error_password']){delete this.state.errors['error_password'];}
		this.setState({
			artpassword: e.target.value,
			wrongpassmsg:''
		})
	}
	onChangeDob(e) {
		this.setState({
			dob: e.target.value
		})
	}

	onChangeGender(e) {
		
		let genderValue = e.target.value;
		if(genderValue === 'male'){
			this.setState({
				radioReading:true,
				radioPlan:false
			});
		}else{
			this.setState({
				radioReading:false,
				radioPlan:true
			});
		}
		
		this.setState({
			gender: e.target.value
		});
	}

	onChangeAddress(e) {
		this.setState({
			address: e.target.value
		})
	}

	onChangeCellphone(e) {
		this.setState({
			cellphone: e.target.value
		})
	}

	onChangeCountry(e){
		this.setState({
			country: e.target.value
		})
	}

	onChangeCity(e) {
		this.setState({
			city: e.target.value
		})
	}

	onChangeStates(e) {
		this.setState({
			states: e.target.value
		})
	}

	onChangeZipcode(e) {
		this.setState({
			zipcode: e.target.value
		})
	}

	onChangeSubscription(e) {
		if(this.state.errors['error_plan']){delete this.state.errors['error_plan'];}
		this.setState({
			planid: e.target.value
		})
	}
	
	onChangeSSN(e) {
		this.setState({
			ssn: e.target.value
		})
	}
	croppedImage = async (img) => {
		this.setState({ profile_pic_path: img });
	};
	
	handleValidation = () => {
		let formIsValid = true;
		let strongRegex = new RegExp("^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#\$%\^&\*])(?=.{8,})");
		if(!this.state.first_name){
			formIsValid = false;
			document.getElementById("f_name").focus();
			errors["error_first_name"] = "Please enter first name.";
		}
		if(!this.state.email){
			formIsValid = false;
			document.getElementById("email").focus();
			errors["email"] = "Please enter email.";
		}else if(!this.validateEmail(this.state.email)){
			formIsValid = false;
			document.getElementById("email").focus();
			errors["email"] = "Please enter valid email.";
		}
		if(this.state.emailExist){
			document.getElementById("email").focus();
			formIsValid = false;
		}
		if(!this.state.artpassword){
			formIsValid = false;
			document.getElementById("pwd").focus();
			errors["error_password"] = "Please enter password.";
		}else if(!strongRegex.test(this.state.artpassword)){
			formIsValid = false;
			document.getElementById("pwd").focus();
			errors["error_password"] = "Password should have minimum 8 character, 1 symbol, 1 uppercase, 1 lowercase.";
		}
		if(!this.state.dob){
			formIsValid = false;
			document.getElementById("dobpicker").focus();
			errors["error_dob"] = "Please select date of birth.";
		}
		if(!this.state.planid){
			formIsValid = false;
			document.getElementById("subscription").focus();
			errors["error_plan"] = "Please select subscription plan.";
		}
		if(!this.state.term){
			formIsValid = false;
			errors["error_term"] = "Please select term & condition.";
		}
		if(!this.state.captcha){
			formIsValid = false;
			errors["error_captcha"] = "Please validate CAPTCHA.";
		}
		if(!this.state.formValidation){
			formIsValid = false;
		}
		if(this.state.ref_code && !this.state.formReferral){
			formIsValid = false;
		}
		if (this.state.selectedFile != null) {
		  const fsize = this.state.selectedFile.size;
		  const file = Math.round(fsize / 1024);
		  if (file >= 5120) {
			formIsValid = false;
			errors['image_error'] = 'File too Big, please select a file less than 5mb.';
		  }
		}
		this.setState({errors: errors});
		return formIsValid;

	}
	handleSubmit = async event => {
		console.log("test",this.state);
		event.preventDefault();
		if(this.handleValidation()){
			this.setState({
				disablebtn:false,
				cnlbtndisable:false
			})
			const { stripe, elements } = this.props;
			if (!stripe || !elements) {
				return;
			}		
			this.setState({submitbuttontext:<div className="d-flex justify-content-center align-items-center" style={{ minHeight: '3vh',float:'right' }}><Spinner style={{ width: '15px', height: '15px', display: 'block'}} variant="light" animation="border" role="status"><span className="sr-only">Loading...</span></Spinner></div>});
			const card = elements.getElement(CardElement);
			const result = await stripe.createToken(card);
			if (result.error) {			
				this.setState({
					successclass: 'errormsg',
					msg: 'Payment process is fail, please try again!',
					submitbuttontext : 'Submit',
					disablebtn: true
				});
			} else {
				let blobval = '';
				if (this.state.selectedFile) {
					blobval = await fetch(this.state.profile_pic_path).then((r) => r.blob());
				}
				this.stripeTokenHandler(result.token,this.state.email,this.state.planid, blobval);
			}
			setTimeout(() => {
				this.setState({
					successclass:'hideclass',
					msg:null,
				});
			}, 5000)
		}
	};
	
	stripeElementChange = (element, name) => {
		this.setState({
			cardError:'',
			formValidation: true
		});
		if (element.complete) {
			this.setState({
				enablesubmitbutton:true
			});
		} else {
			if(element.error){
				if(element.error.code){
					this.setState({
						enablesubmitbutton:false,
						formValidation: false,
						cardError: element.error.message
					});
				}
			}
			
		}
	}

	stripeTokenHandler(token,email,planid,blobval){
		this.setState({
			loader:true
		});
		const paymentData = { token: token.id, email: email, membership: planid};
		Axios.post(base_api_url + 'stripepay.php', paymentData, { axiosConfig })
			.then(
				(res) => {
					if (res.data.res_status == 200) {
						const dob = moment(this.state.dob);
						const formData = new FormData();
						if (this.state.selectedFile) {
							formData.append('image', blobval, this.state.selectedprofile);
						}
						formData.append("subscription_id", res.data.res_data);
						formData.append("first_name", this.state.first_name);
						formData.append("last_name", this.state.last_name);
						formData.append("email", this.state.email);
						formData.append("artpassword", this.state.artpassword);
						formData.append("dob", dob.format('yyyy-MM-DD'));
						formData.append("gender", this.state.gender);
						formData.append("address", this.state.address);
						formData.append("cellphone", this.state.cellphone);
						formData.append("country", this.state.country);
						formData.append("ssn", this.state.ssn);
						formData.append("city", this.state.city);
						formData.append("states", this.state.states);
						formData.append("zipcode", this.state.zipcode);
						formData.append("planid", this.state.planid);
						formData.append("roleid", this.state.role);
						formData.append("referral", this.state.ref_code);
						formData.append("code_type", this.state.code_type);
						Axios.post(base_api_url + 'add-user.php', formData, { axiosConfig })
							.then(
								(res) => {
									window.scrollTo(0, 0);
									if (res.data.res_status == 200) {
										this.setState({
											loader:null,
											redirect: false,
											successclass: 'successmsg',
											submitbuttontext : 'Submit',
											msg: 'Congratulations, your account is successfully created. Please refer your registered email Id for activation link.'
										});
										this.cancelform();
									} else {
										window.scrollTo(0, 0);
										this.setState({
											loader:null,
											redirect: false,
											successclass: 'errormsg',
											submitbuttontext : 'Submit',
											msg: 'Registration process is failed, please try again!'
										})
									}
									setTimeout(() => {
										this.setState({
											loader:null,
											submitbuttontext : 'Submit',
											successclass: 'hideclass',
											msg: null,
											redirect: true
										});
										return <Redirect to="/" />
									}, 5000);
								}
							);
					
					} else {
						window.scrollTo(0, 0);
						this.setState({
							successclass: 'errormsg',
							msg: res.data.res_message,
							loader:null,
							submitbuttontext : 'Submit',
							disablebtn: true,
							payment: false
						})
					}
				}
			);
	}
	
	handleRecaptchaChange = value => {
		if(this.state.errors['error_captcha']){delete this.state.errors['error_captcha'];}
		if(value){
			this.setState({
				captcha:true
			});
		}else{
			this.setState({
				captcha:false
			});
		}
		this.setState({ value });
		// if value is null recaptcha expired
		if (value === null) this.setState({ expired: "true" });
	};

	asyncScriptOnLoad = () => {
		this.setState({ callback: "called!" });
		// console.log("scriptLoad - reCaptcha Ref-", this._reCaptchaRef);
	};
	
	cancelform = (e) => {
		this.setState({
			first_name : '',
			last_name: '',
			email: '',
			artpassword: '',
			dob: '',
			gender: '',
			address: '',
			cellphone: '',
			city: '',
			states: '',
			zipcode: '',
			planid: '',
			ssn:'',
			planid:'',
			ref_code:''
		});
		this.refs.minus.checked = false;
		this.refs.imageFile.value = '';
		const { elements, stripe } = this.props;
	    const cardElement = elements.getElement(CardElement);
	    if(cardElement){
	      cardElement.clear();
	    }
	}
	onclickseturl = (urlval) => {
		this.setState({
		  urlvalinitial: urlval
		});
		$('#myModal').modal('show');
	};
	addDefaultSrc = (ev) => {
		ev.target.src = defaultimg;
	};
	render() {
		const { value, callback, load, expired } = this.state || {};
		let radioReadingChecked = (this.state.radioReading)?'checked':'';
		let radioPlanChecked 	= (this.state.radioPlan)?'checked':'';
		let celebrityRadio = (this.state.celebrityRadio)?'checked':'';
		let churchRadio 	= (this.state.churchRadio)?'checked':'';
		let disabled = (this.state.disabled)?"disabled":"";
		if (this.state.redirect==true) {
			return <Redirect to="/login" />
		}else{
		return (
			<React.Fragment>
				<section className="become-artist-form">
					<div className="container">
					<div className="col-md-12"><div className={this.state.successclass}>{this.state.msg}</div></div>
					
						<div className="become-artist-part">
							<div className="row">
								<div className="contents_right col-md-12">
									<form ref={(el) => this.myFormRef = el} id="registration" name="registration" onSubmit={this.handleSubmit}>
										<div className="row">
											<div className="col-md-6">
												<div className="artist-form-part">
													<legend>{(this.state.role == '1')?'Listener':'Artist'} Registration</legend>
													<div className="row">
														<div className="col-md-6">
															<div className="form-group">
																<label>First Name<span className="red">*</span></label>
																<input type="text" tabIndex="1" className="form-control" placeholder="First Name" id="f_name" value={this.state.first_name} onChange={this.onChangeFirstName} />
																<font className="errorMsg">{this.state.errors["error_first_name"]}</font>
															</div>
														</div>
														<div className="col-md-6">
															<div className="form-group">
																<label>Last Name</label>
																<input type="text" tabIndex="2" className="form-control" id="l-name" placeholder="Last Name" value={this.state.last_name} onChange={this.onChangeLastName} />
															</div>
														</div>
													</div>
													<div className="row">
														<div className="col-md-12">
															<div className="form-group">
																<label>Email<span className="red">*</span></label>
																<input type="text" className="form-control" id="email" placeholder="Email" tabIndex="3" value={this.state.email} onChange={this.onChangeEmail}/>
																<font className="errorMsg">{this.state.errors["email"]}</font>
																<span className="errorMsg">{this.state.emailmsg}</span>
															</div>
														</div>
													</div>
													<div className="row">
														<div className="col-md-12">
															<div className="form-group">
																<label>Password<span className="red">*</span></label>
																<input type="password" tabIndex="4" className="form-control" id="pwd" placeholder="Password" value={this.state.artpassword} onChange={this.onChangeArtPassword}/>
																<font className="errorMsg">{this.state.errors["error_password"]}</font>
																<span className="wrongpassmsg-1">{this.state.wrongpassmsg}</span>
															</div>
														</div>
													</div>
													<div className="row">
														<div className="col-md-12">
															<div className="form-group dobpicker">
																<label>Date of Birth<span className="red">*</span></label>
																
																<DatePicker
																  selected={ this.state.dob }
																  onChange={ this.handleChange }
																  name="startDate"
																  dateFormat="MM/dd/yyyy"
																  dropdownMode="select"
																  showMonthDropdown
																  showYearDropdown
																  adjustDateOnChange
																  minDate={new Date('1940/01/01')}
																  maxDate={new Date()}
																  placeholderText = "Date of Birth"
																  className="form-control"
																  id="dobpicker"
																  tabIndex="5"
																  onKeyDown={e => e.preventDefault()}
															  />
															  <font className="errorMsg">{this.state.errors["error_dob"]}</font>
															  <label className="datepickercalender" htmlFor="dobpicker"><i className="fa fa-calendar" aria-hidden="true"></i></label>
															</div>
														</div>
													</div>
													<div className="row">
														<div className="col-md-12">
															<div className="form-group">
																<label htmlFor="is_new_release">Gender</label><br />
																<div className="custom-control custom-radio custom-control-inline">
																	<input type="radio" tabIndex="6" id="newrelease" name="gender" value="male" onChange={this.onChangeGender} className="custom-control-input" checked={radioReadingChecked} />
																	<label className="custom-control-label" htmlFor="newrelease">Male</label>
																</div>
																<div className="custom-control custom-radio custom-control-inline">
																	<input type="radio" tabIndex="7" id="newrelease2" value="female" onChange={this.onChangeGender} name="gender" className="custom-control-input"  checked={radioPlanChecked} />
																	<label className="custom-control-label" htmlFor="newrelease2">Female</label>
																</div>
															</div>
														</div>
													</div>
													<div className="row">
														<div className="col-md-6">
															<div className="form-group">
																<label>Phone No.</label>
																<InputMask {...this.props} className="form-control" placeholder="Phone No." mask="(999) 999-9999" tabIndex="8" maskChar="" value={this.state.cellphone} onChange={this.onChangeCellphone} id="phoneN" />
															</div>
														</div>
														{(this.state.role == 2)?
															<>
															<div className="col-md-6">
																<div className="form-group">
																	<label>SSN
																	  <span className="helpicon"><i className="fa fa-question-circle" aria-hidden="true"></i></span>
																	  <span className="helpiconactive helpiconssn">
																		<p>This enables you to receive payments and proper tax documents at year end.</p>
																	  </span>
																	</label>
																	<InputMask {...this.props} className="form-control" placeholder="SSN" mask="999-99-9999" tabIndex="9" maskChar="" value={this.state.ssn} onChange={this.onChangeSSN} id="ssn" />
																</div>
															</div>
															</>:""
														}
														
													</div>
													<div className="form-group">
														<label>Country</label>
														<select name="country" id="country" className="form-control" onChange={this.onChangeCountry} tabIndex="10">
															<option>--Select Country--</option>
															{this.state.countrylist.map((result) => {
																return (<option value={result.key}>{result.value}</option>)
																})}
														</select>
													</div>
													<div className="form-group">
														<label>Address</label>
														<input type="text" tabIndex="11" className="form-control" id="address" value={this.state.address} onChange={this.onChangeAddress} placeholder="Address" />
													</div>
													
													<div className="row">
														<div className="col-md-4">
															<div className="form-group ">
																<label>City</label>
																<input type="text" tabIndex="12" className="form-control" value={this.state.city} onChange={this.onChangeCity} id="city" placeholder="City" />
															</div>
														</div>
														<div className="col-md-4">
															<div className="form-group ">
																<label>State</label>
																<input type="text" tabIndex="13" className="form-control" value={this.state.states} onChange={this.onChangeStates} id="state" placeholder="State" />
															</div>
														</div>
														<div className="col-md-4">
															<div className="form-group ">
																<label>Zip Code</label>
																<InputMask {...this.props} type="text" className="form-control" tabIndex="14" value={this.state.zipcode} onChange={this.onChangeZipcode} mask="999999" maskChar=" " id="zip" placeholder="Zip Code" />
															</div>
														</div>
													</div>
													<div className="row">
														<div className="col-md-12">
														 {(disabled)?
														 	<div className="form-group">
																<label htmlFor="is_new_release">Referral Code Type</label><br />
																<div className="custom-control custom-radio custom-control-inline">
																	<input type="radio" id="lebel_for_celebrity" name="code_type" value="celebrity" className="custom-control-input" checked={celebrityRadio} disabled/>
																	<label className="custom-control-label" htmlFor="lebel_for_celebrity">Celebrity</label>
																</div>
																<div className="custom-control custom-radio custom-control-inline">
																	<input type="radio" id="lebel_for_church" value="church" name="code_type" className="custom-control-input" checked={churchRadio} disabled/>
																	<label className="custom-control-label" htmlFor="lebel_for_church">Church</label>
																</div>
															</div>
														 	:
															<div className="form-group">
																<label htmlFor="is_new_release">Referral Code Type</label><br />
																<div className="custom-control custom-radio custom-control-inline">
																	<input type="radio" id="lebel_for_celebrity" name="code_type" value="celebrity" onChange={this.onChangeCodeType.bind(this)} className="custom-control-input" checked={celebrityRadio}/>
																	<label className="custom-control-label" htmlFor="lebel_for_celebrity">Celebrity</label>
																</div>
																<div className="custom-control custom-radio custom-control-inline">
																	<input type="radio" id="lebel_for_church" value="church" onChange={this.onChangeCodeType.bind(this)} name="code_type" className="custom-control-input" checked={churchRadio}/>
																	<label className="custom-control-label" htmlFor="lebel_for_church">Church</label>
																</div>
															</div>
															}															
														</div>
													</div>
													<div className="row">
														<div className="col-md-6">
															<div className="form-group ">
																<label>Referral Code</label>
																{(this.state.readOnly == 'true')?
																	<input type="text" tabIndex="15" className="form-control" value={this.state.ref_code} onChange={this.changeReferralCode.bind(this)} onBlur={()=>this.checkReferralCode(this.state.ref_code)} placeholder="Referral Code" readonly=""/>:
																	<input type="text" tabIndex="15" className="form-control" value={this.state.ref_code} onChange={this.changeReferralCode.bind(this)} onBlur={()=>this.checkReferralCode(this.state.ref_code)} placeholder="Referral Code" />
																}
																
																<font className="errorMsg">{this.state.error_msg}</font>
															</div>
														</div>
														<div className="col-md-6">
															<div className="form-group ">
																<label>{this.state.label}</label>
																<input type="text" className="form-control" value={this.state.cel_church_name} placeholder={this.state.label} readonly=""/>
															</div>
														</div>
													</div>
												</div>
											</div>

											<div className="col-md-6">
												<div className="artist-form-part">
													<div className="form-group">
														<label>Profile Picture</label>
														<div className="avatar-data">
															<input type="file" id="avatar" tabIndex="15" name="myfile" onChange={this.onFileChange} placeholder="Avatar" aria-invalid="false" accept="image/*" ref="imageFile" />
														</div>
														<div className="previewa">
															<CropAndPreview
															show={this.state.showCropAndPreview}
															data={{ src: this.state.selectedFile }}
															croppedImages={this.croppedImage}
															handleShow={this.handleShow}
															/>
															<img
															onError={this.addDefaultSrc}
															src={this.state.profile_pic_path}
															className="img-responsive img-circle"
															style={{ width: '100px', height: '100px', marginTop:'5px' }}
															onClick={() => this.onclickseturl(this.state.profile_pic_path)}
															/>
														</div>
													</div>
													<div className="form-group">
														<label>Subscription<span className="red">*</span></label>
														<div className="subsc">
															<select id="subscription" tabIndex="16" required className="form-control" name="" onChange={this.onChangeSubscription} value={this.state.planid} >
																<option value="0">--Select Membership Plan--</option>
															  {this.state.planlist.map((result) => {
																return (<option value={result.id}>{result.plan} ${result.amount}</option>)
																})}
															</select>
															<font className="errorMsg">{this.state.errors["error_plan"]}</font>
														</div>
													</div>
													<div className="form-group">
														<label>Credit Card</label>
														<div className="creditcardsection"><CardElement options={{ hidePostalCode: true }} onChange={(element) => this.stripeElementChange(element, 'card_number')} tabIndex="17"/>
														</div>														
														<font className="errorMsg">{this.state.cardError}</font>
													</div>
													<div className="form-group">
														<div><label>Terms & Conditions</label>
															<div className="termsbox">
																<p><span className="terms_heading"><strong>Terms and Conditions</strong><strong> of Use</strong></span></p>
							<p>Welcome and thank you for choosing Conquer Music Companies LLC (“Conqer Music,” “we,” “us,” “our”). The conqermusic.com website (the "Site") is comprised of various web pages operated by Conquer Music Companies LLC and is offered to you conditioned on your acceptance without modification of the terms, conditions, and notices contained herein (the "Terms"). Your use of conqermusic.com constitutes your agreement to all such Terms. Please read these terms carefully and keep a copy of them for your reference.</p>
							<p>Conqer Music is a music streaming site that provides personalized services with social and interactive features for streaming music and other content as well as other products and services that may be developed from time to time. Subscribe to listen to Christian music or as an artist to post your music and talk to everyone in the network. You can also buy Conqer merchandise, post and buy tickets for Christian events and request prayer. </p>
							<p>By signing up or otherwise using any of our services, including all associated features and functionalities, websites and user interfaces, as well as all content and software applications associated with our services (collectively, the “Service”), or accessing any music, videos or other content or material that is made available through the Service (the “Content”) you are entering into a binding contract with Conquer Music Companies, LLC.</p>
							<p className="goldtext"><strong>1.0 Service Options</strong></p>
							<p>The Conqer Music Service requires payment before you can access it (the “Subscription”). We may also offer special promotional plans, memberships, or services, including offerings of third-party products and services in conjunction with or through the Conqer Music Service. We are not responsible for the products and services provided by such third parties. We reserve the right to modify, terminate or otherwise amend our offered subscription plans and promotional offerings at any time in accordance with these Terms.</p>
							<p>If you have purchased or received a code, gift card, pre-paid offer or other offer provided or sold by or on behalf of Conqer for access to a Subscription (“Code”), separate terms and conditions presented to you along with the Code may also apply to your access to the Service and you agree to comply with any such terms and conditions. You may also purchase access to a Subscription through a third party. In such cases, separate terms and conditions with such third party in addition to the Agreements may apply to your access to the Service.</p>
							<p className="goldtext"><strong>1.1 Trials</strong></p>
							<p>From time to time, we or others on our behalf may offer trials of a Subscription for a specified period without payment or at a reduced rate (a “Trial”). Conqer Music may determine your eligibility for a Trial and withdraw or modify a Trial at any time without prior notice and with no liability, to the extent permitted under applicable law.</p>
							<p>Trials will require you to provide your payment details to start the Trial. By providing such details you agree that we may automatically begin charging you for the Subscription cost on the first day following the end of the Trial on a recurring monthly basis or another interval that we disclose to you in advance. IF YOU DO NOT WANT THIS CHARGE, YOU MUST CANCEL THE APPLICABLE SUBSCRIPTION BEFORE THE END OF THE TRIAL BY CLICKING HERE IF YOU SIGNED UP FOR THE TRIAL THROUGH CONQER MUSIC, OR IF YOU RECEIVED YOUR TRIAL THROUGH A THIRD PARTY, YOU MUST CANCEL THE APPLICABLE PAID SUBSCRIPTION THROUGH THE THIRD PARTY</p>
							<p className="goldtext"><strong>2 Payments and Cancellations</strong></p>
							<p className="goldtext"><strong>2.1 Billing</strong></p>
							<p>You may purchase a Subscription directly from Conqer Music or through a third party either by (1) paying a subscription fee in advance on a monthly basis or some other recurring interval disclosed to you prior to your purchase; or (2) pre-payment giving you access to the Conqer Music Service for a specific time period (“Pre-Paid Period”). Payments made to and from Conqer music will be facilitated through <a href="https://stripe.com/get-started?utm_campaign=paid_brand-US%20%7C%20Search%20%7C%20Brand%20%7C%20Stripe-351718373&utm_medium=cpc&utm_source=bing&utm_content=&utm_term=EXA_Stripe%20Only-stripe-e&utm_adposition=&utm_device=c&msclkid=51c2db43f1eb1ee2d52186a044dd86d5">Stripe</a> and applicable terms of service will apply. All music loaded to Conqer Music service requires an ISRC code. If a user requires an ISRC code and has not already obtain one, we reserve the right to charge a service fee in addition to authority fees to obtain the ISRC code on your behalf. </p>
							<p>Conqer Music may change the price for our Subscription, including recurring subscription fees, the Pre-Paid Period (for periods not yet paid), or Codes, from time to time and will communicate any price changes to you in advance and, if applicable, how to accept those changes. Price changes will take effect at the start of the next subscription period following the date of the price change. Subject to applicable law, you accept the new price by continuing to use the Conqer Music Service after the price change takes effect. If you do not agree with a price change, you have the right to reject the change by unsubscribing from the Subscription prior to the price change going into effect.</p>
							<p className="goldtext"><strong>2.2 Renewal; Cancellation</strong></p>
							<p>Unless your Subscription has been purchased for a Pre-Paid Period, your payment to Conqer Music or the third party through which you purchased the Subscription will automatically renew at the end of the applicable subscription period, unless you cancel your Subscription before the end of the then-current subscription period by clicking here if you purchased the Subscription through Conqer Music, or if you purchased the Subscription through a third party, by canceling the Subscription through such third party. The cancellation will take effect the day after the last day of the current subscription period. We do not provide refunds or credits for any partial subscription periods.</p>
							<p>If you have purchased a Subscription using a Code, your subscription will automatically terminate at the end of the period stated in the Code and will auto renew at standard rates, or cancel if there is an insufficient balance to pay for the Service. If you have purchased your Subscription through a third party, you must cancel directly with that third party.</p>
							<p className="goldtext"><strong>3.0 Third Party Applications and Devices</strong></p>
							<p>The Conqer Music Service is integrated with or may otherwise interact with third party applications, websites, and services (“Third Party Applications”) and third party Devices to make the Conqer Music Service available to you. These Third Party Applications and Devices may have their own terms and conditions of use and privacy policies and your use of these Third Party Applications and Devices will be governed by and subject to such terms and conditions and privacy policies. You understand and agree that Conqer Music does not endorse and is not responsible or liable for the behavior, features, or content of any Third Party Application or Device or for any transaction you may enter into with the provider of any such Third Party Applications and Devices, nor does Conqer Music warrant the compatibility or continuing compatibility of the Third Party Applications and Devices with the Service.</p>
							<p className="goldtext"><strong>4.0 Electronic Communications</strong></p>
							<p>Visiting conqermusic.com or sending emails to Conqer Music constitutes electronic communications. You consent to receive electronic communications and you agree that all agreements, notices, disclosures and other communications that we provide to you electronically, via email and on the Site, satisfy any legal requirement that such communications be in writing.</p>
							<p className="goldtext"><strong>5.0 Your Account</strong></p>
							<p>If you use this site, you are responsible for maintaining the confidentiality of your account and password and for restricting access to your computer, and you agree to accept responsibility for all activities that occur under your account or password. You may not assign or otherwise transfer your account to any other person or entity. You acknowledge that Conqer Music is not responsible for third party access to your account that results from theft or misappropriation of your account. Conqer Music and its associates reserve the right to refuse or cancel service, terminate accounts, or remove or edit content in our sole discretion.</p>
							<p className="goldtext"><strong>6.0 Children Under Thirteen</strong></p>
							<p>Conqer Music does not knowingly collect, either online or offline, personal information from persons under the age of thirteen. If you are under 18, you may use conqermusic.com only with permission of a parent or guardian.</p>
							<p className="goldtext"><strong>7.0 Links to Third Party Sites/Third Party Services</strong></p>
							<p>conqermusic.com may contain links to other websites ("Linked Sites"). The Linked Sites are not under the control of Conqer Music and Conqer Music is not responsible for the contents of any Linked Site, including without limitation any link contained in a Linked Site, or any changes or updates to a Linked Site. Conqer Music is providing these links to you only as a convenience, and the inclusion of any link does not imply endorsement by Conqer Music of the site or any association with its operators.</p>
							<p>Certain services made available via www.conqermusic.com are delivered by third party sites and organizations. By using any product, service or functionality originating from the www.conqermusic.com domain, you hereby acknowledge and consent that Conqer Music may share such information and data with any third party with whom Conqer Music has a contractual relationship to provide the requested product, service or functionality on behalf of www.conqermusic.com users and customers.</p>
							<p className="goldtext"><strong>8.0 No Unlawful or Prohibited Use/Intellectual Property </strong></p>
							<p>You are granted a non-exclusive, non-transferable, revocable license to access and use www.conqermusic.com strictly in accordance with these terms of use. As a condition of your use of the Site, you warrant to Conqer Music that you will not use the Site for any purpose that is unlawful or prohibited by these Terms. You may not use the Site in any manner which could damage, disable, overburden, or impair the Site or interfere with any other party's use and enjoyment of the Site. You may not obtain or attempt to obtain any materials or information through any means not intentionally made available or provided for through the Site.</p>
							<p>All content included as part of the Service, such as text, graphics, logos, images, as well as the compilation thereof, and any software used on the Site, is the property of Conqer Music or its suppliers and protected by copyright and other laws that protect intellectual property and proprietary rights. You agree to observe and abide by all copyright and other proprietary notices, legends or other restrictions contained in any such content and will not make any changes thereto.</p>
							<p>You will not modify, publish, transmit, reverse engineer, participate in the transfer or sale, create derivative works, or in any way exploit any of the content, in whole or in part, found on the Site. Conqer Music content is not for resale. Your use of the Site does not entitle you to make any unauthorized use of any protected content, and in particular you will not delete or alter any proprietary rights or attribution notices in any content. You will use protected content solely for your personal use and will make no other use of the content without the express written permission of Conqer Music and the copyright owner. You agree that you do not acquire any ownership rights in any protected content. We do not grant you any licenses, express or implied, to the intellectual property of Conqer Music or our licensors except as expressly authorized by these Terms.</p>
							<p className="goldtext"><strong>9.0 Use of Communication Services</strong></p>
							<p>The Site may contain bulletin board services, chat areas, news groups, forums, communities, personal web pages, calendars, and/or other message or communication facilities designed to enable you to communicate with the public at large or with a group (collectively, "Communication Services"). You agree to use the Communication Services only to post, send and receive messages and material that are proper and related to the particular Communication Service.</p>
							<p>By way of example, and not as a limitation, you agree that when using a Communication Service, you will not: defame, abuse, harass, stalk, threaten or otherwise violate the legal rights (such as rights of privacy and publicity) of others; publish, post, upload, distribute or disseminate any inappropriate, profane, defamatory, infringing, obscene, indecent or unlawful topic, name, material or information; upload files that contain software or other material protected by intellectual property laws (or by rights of privacy of publicity) unless you own or control the rights thereto or have received all necessary consents; upload files that contain viruses, corrupted files, or any other similar software or programs that may damage the operation of another's computer; advertise or offer to sell or buy any goods or services for any business purpose, unless such Communication Service specifically allows such messages; conduct or forward surveys, contests, pyramid schemes or chain letters; download any file posted by another user of a Communication Service that you know, or reasonably should know, cannot be legally distributed in such manner; falsify or delete any author attributions, legal or other proper notices or proprietary designations or labels of the origin or source of software or other material contained in a file that is uploaded; restrict or inhibit any other user from using and enjoying the Communication Services; violate any code of conduct or other guidelines which may be applicable for any particular Communication Service; harvest or otherwise collect information about others, including e-mail addresses, without their consent; violate any applicable laws or regulations.</p>
							<p>Conqer Music has no obligation to monitor Communication Services. However, Conqer Music reserves the right to review materials posted to a Communication Service and to remove any materials in its sole discretion. Conqer Music reserves the right to terminate your access to any or all of the Communication Services at any time without notice for any reason whatsoever.</p>
							<p>Conqer Music reserves the right at all times to disclose any information as necessary to satisfy any applicable law, regulation, legal process or governmental request, or to edit, refuse to post or to remove any information or materials, in whole or in part, in Conqer Music's sole discretion.</p>
							<p>Always use caution when giving out any personally identifying information about yourself or your children in any Communication Service. Conqer Music does not control or endorse the content, messages or information found in any Communication Service and, therefore, Conqer Music specifically disclaims any liability with regard to the Communication Services and any actions resulting from your participation in any Communication Service. Managers and hosts are not authorized Conqer Music spokespersons, and their views do not necessarily reflect those of Conqer Music.</p>
							<p>Materials uploaded to a Communication Service may be subject to posted limitations on usage, reproduction and/or dissemination. You are responsible for adhering to such limitations if you upload the materials.</p>
							<p className="goldtext"><strong>10.0 Materials Provided to conqermusic.com or Posted on Any Conqer Music Web Page</strong></p>
							<p>Conqer Music does not claim ownership of the materials you provide to www.conqermusic.com (including feedback and suggestions) or post, upload, input or submit to any Conqer Music site or our associated services (collectively "Submissions"). However, by posting, uploading, inputting, providing or submitting your Submission you are granting Conqer Music, our affiliated companies and necessary sublicensees permission to use your Submission in connection with the operation of their Internet businesses including, without limitation, the rights to: copy, distribute, transmit, publicly display, publicly perform, reproduce, edit, translate and reformat your Submission; and to publish your name in connection with your Submission.</p>
							<p>No compensation will be paid with respect to the use of your Submission, as provided herein. Conqer Music is under no obligation to post or use any Submission you may provide and may remove any Submission at any time in Conqer Music's sole discretion.</p>
							<p>By posting, uploading, inputting, providing or submitting your Submission, you warrant and represent that you own or otherwise control all of the rights to your Submission as described in this section including, without limitation, all the rights necessary for you to provide, post, upload, input or submit the Submissions.</p>
							<p className="goldtext"><strong>11.0 International Users</strong></p>
							<p>The Service is controlled, operated and administered by Conqer Music from our offices within the USA. If you access the Service from a location outside the USA, you are responsible for compliance with all local laws. You agree that you will not use the Conqer Music Content accessed through www.conqermusic.com in any country or in any manner prohibited by any applicable laws, restrictions or regulations.</p>
							<p className="goldtext"><strong>12.0 Indemnification</strong></p>
							<p>You agree to indemnify, defend and hold harmless Conqer Music, its officers, directors, employees, agents and third parties, for any losses, costs, liabilities and expenses (including reasonable attorney's fees) relating to or arising out of your use of or inability to use the Site or services, any user postings made by you, your violation of any terms of this Agreement or your violation of any rights of a third party, or your violation of any applicable laws, rules or regulations. Conqer Music reserves the right, at its own cost, to assume the exclusive defense and control of any matter otherwise subject to indemnification by you, in which event you will fully cooperate with Conqer Music in asserting any available defenses.</p>
							<p className="goldtext"><strong>13.0 Arbitration</strong></p>
							<p>In the event the parties are not able to resolve any dispute between them arising out of or concerning these Terms and Conditions, or any provisions hereof, whether in contract, tort, or otherwise at law or in equity for damages or any other relief, then such dispute shall be resolved only by final and binding arbitration pursuant to the Federal Arbitration Act, conducted by a single neutral arbitrator and administered by the American Arbitration Association, or a similar arbitration service selected by the parties, in a location mutually agreed upon by the parties. The arbitrator's award shall be final, and judgment may be entered upon it in any court having jurisdiction. In the event that any legal or equitable action, proceeding or arbitration arises out of or concerns these Terms and Conditions, the prevailing party shall be entitled to recover its costs and reasonable attorney's fees. The parties agree to arbitrate all disputes and claims in regard to these Terms and Conditions or any disputes arising as a result of these Terms and Conditions, whether directly or indirectly, including Tort claims that are a result of these Terms and Conditions. The parties agree that the Federal Arbitration Act governs the interpretation and enforcement of this provision. The entire dispute, including the scope and enforceability of this arbitration provision shall be determined by the Arbitrator. This arbitration provision shall survive the termination of these Terms and Conditions.</p>
							<p className="goldtext"><strong>14.0 Class Action Waiver</strong></p>
							<p>Any arbitration under these Terms and Conditions will take place on an individual basis; class arbitrations and class/representative/collective actions are not permitted. THE PARTIES AGREE THAT A PARTY MAY BRING CLAIMS AGAINST THE OTHER ONLY IN EACH'S INDIVIDUAL CAPACITY, AND NOT AS A PLAINTIFF OR CLASS MEMBER IN ANY PUTATIVE CLASS, COLLECTIVE AND/ OR REPRESENTATIVE PROCEEDING, SUCH AS IN THE FORM OF A PRIVATE ATTORNEY GENERAL ACTION AGAINST THE OTHER. Further, unless both you and Conqer Music agree otherwise, the arbitrator may not consolidate more than one person's claims and may not otherwise preside over any form of a representative or class proceeding.</p>
							<p className="goldtext"><strong>15.0 Liability Disclaimer</strong></p>
							<p>THE INFORMATION, SOFTWARE, PRODUCTS, AND SERVICES INCLUDED IN OR AVAILABLE THROUGH THE SITE MAY INCLUDE INACCURACIES OR TYPOGRAPHICAL ERRORS. CHANGES ARE PERIODICALLY ADDED TO THE INFORMATION HEREIN. CONQUER MUSIC COMPANIES LLC AND/OR ITS SUPPLIERS MAY MAKE IMPROVEMENTS AND/OR CHANGES IN THE SITE AT ANY TIME.</p>
							<p>CONQUER MUSIC COMPANIES LLC AND/OR ITS SUPPLIERS MAKE NO REPRESENTATIONS ABOUT THE SUITABILITY, RELIABILITY, AVAILABILITY, TIMELINESS, AND ACCURACY OF THE INFORMATION, SOFTWARE, PRODUCTS, SERVICES AND RELATED GRAPHICS CONTAINED ON THE SITE FOR ANY PURPOSE. TO THE MAXIMUM EXTENT PERMITTED BY APPLICABLE LAW, ALL SUCH INFORMATION, SOFTWARE, PRODUCTS, SERVICES AND RELATED GRAPHICS ARE PROVIDED "AS IS" WITHOUT WARRANTY OR CONDITION OF ANY KIND. CONQUER MUSIC COMPANIES LLC AND/OR ITS SUPPLIERS HEREBY DISCLAIM ALL WARRANTIES AND CONDITIONS WITH REGARD TO THIS INFORMATION, SOFTWARE, PRODUCTS, SERVICES AND RELATED GRAPHICS, INCLUDING ALL IMPLIED WARRANTIES OR CONDITIONS OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE, TITLE AND NON-INFRINGEMENT.</p>
							<p>TO THE MAXIMUM EXTENT PERMITTED BY APPLICABLE LAW, IN NO EVENT SHALL CONQUER MUSIC COMPANIES LLC AND/OR ITS SUPPLIERS BE LIABLE FOR ANY DIRECT, INDIRECT, PUNITIVE, INCIDENTAL, SPECIAL, CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER INCLUDING, WITHOUT LIMITATION, DAMAGES FOR LOSS OF USE, DATA OR PROFITS, ARISING OUT OF OR IN ANY WAY CONNECTED WITH THE USE OR PERFORMANCE OF THE SITE, WITH THE DELAY OR INABILITY TO USE THE SITE OR RELATED SERVICES, THE PROVISION OF OR FAILURE TO PROVIDE SERVICES, OR FOR ANY INFORMATION, SOFTWARE, PRODUCTS, SERVICES AND RELATED GRAPHICS OBTAINED THROUGH THE SITE, OR OTHERWISE ARISING OUT OF THE USE OF THE SITE, WHETHER BASED ON CONTRACT, TORT, NEGLIGENCE, STRICT LIABILITY OR OTHERWISE, EVEN IF CONQUER MUSIC COMPANIES LLC OR ANY OF ITS SUPPLIERS HAS BEEN ADVISED OF THE POSSIBILITY OF DAMAGES. BECAUSE SOME STATES/JURISDICTIONS DO NOT ALLOW THE EXCLUSION OR LIMITATION OF LIABILITY FOR CONSEQUENTIAL OR INCIDENTAL DAMAGES, THE ABOVE LIMITATION MAY NOT APPLY TO YOU. IF YOU ARE DISSATISFIED WITH ANY PORTION OF THE SITE, OR WITH ANY OF THESE TERMS OF USE, YOUR SOLE AND EXCLUSIVE REMEDY IS TO DISCONTINUE USING THE SITE.</p>
							<p className="goldtext"><strong>16.0 Termination/Access Restriction</strong></p>
							<p>Conqer Music reserves the right, in its sole discretion, to terminate your access to the Site and the related services or any portion thereof at any time, without notice. To the maximum extent permitted by law, this agreement is governed by the laws of the State of California and you hereby consent to the exclusive jurisdiction and venue of courts in California in all disputes arising out of or relating to the use of the Site. Use of the Site is unauthorized in any jurisdiction that does not give effect to all provisions of these Terms, including, without limitation, this section.</p>
							<p>You agree that no joint venture, partnership, employment, or agency relationship exists between you and Conqer Music as a result of this agreement or use of the Site. Conqer Music's performance of this agreement is subject to existing laws and legal process, and nothing contained in this agreement is in derogation of Conqer Music's right to comply with governmental, court and law enforcement requests or requirements relating to your use of the Site or information provided to or gathered by Conqer Music with respect to such use. If any part of this agreement is determined to be invalid or unenforceable pursuant to applicable law including, but not limited to, the warranty disclaimers and liability limitations set forth above, then the invalid or unenforceable provision will be deemed superseded by a valid, enforceable provision that most closely matches the intent of the original provision and the remainder of the agreement shall continue in effect.</p>
							<p>Unless otherwise specified herein, this agreement constitutes the entire agreement between the user and Conqer Music with respect to the Site and it supersedes all prior or contemporaneous communications and proposals, whether electronic, oral or written, between the user and Conqer Music with respect to the Site. A printed version of this agreement and of any notice given in electronic form shall be admissible in judicial or administrative proceedings based upon or relating to this agreement to the same extent and subject to the same conditions as other business documents and records originally generated and maintained in printed form. It is the express wish to the parties that this agreement and all related documents be written in English.</p>
							<p className="goldtext"><strong>17.0 Changes to Terms</strong></p>
							<p>Conqer Music reserves the right, in its sole discretion, to change the Terms under which conqermusic.com is offered. The most current version of the Terms will supersede all previous versions. Conqer Music encourages you to periodically review the Terms to stay informed of our updates.</p>
							<p className="goldtext"><strong>Contact Us</strong></p>
							<p>Conqer Music welcomes your questions or comments regarding the Terms:</p>
							<p>Conquer Music Companies LLC<br />P.O. Box 407<br />Blandon, Pennsylvania 19510</p>
							<p><span className="terms_text_color">Email Address:</span><br />info@conqermusic.com</p>
							<p><span className="terms_text_color">Telephone number:</span></p>
							<p>Effective as of December 04, 2019</p>
															</div>
														</div>
														<div className="checkbox mt-3">
															<label>
																<input className="check-h" tabIndex="18" type="checkbox" name="" onChange={this.termCondition} ref="minus"/>
																<Link to={'/terms-and-conditions'} activeclassname="active" target="_blank">I Agree To Terms of Service<span className="red">*</span></Link>
																</label><br />
																<font className="errorMsg">{this.state.errors["error_term"]}</font>
														</div>
													</div>
													<div className="mb-3 overridethis">
														{/*load && (
														  <ReCAPTCHA
															theme="light"
															ref={this._reCaptchaRef}
															sitekey={TEST_SITE_KEY}
															onChange={this.handleRecaptchaChange}
															asyncScriptOnLoad={this.asyncScriptOnLoad}
														  />
														) */}
														<font className="errorMsg">{this.state.errors["error_captcha"]}</font> 
													</div> 
													<div className="btn-toolbar-inner form-group">
														<div className="btn-group">
															<button disabled={(!this.state.disablebtn)?'disabled':'' } className="btn"><i className="fa fa-check" aria-hidden="true"></i>{this.state.submitbuttontext} </button>
														</div>
														<div className="btn-group cancelbthns">
															<button type="button" className="btn" onClick={() => this.cancelform()} disabled={(!this.state.cnlbtndisable)?'disabled':'' }><i className="fa fa-refresh" aria-hidden="true"></i>Reset </button>
														</div>
													</div>
												</div>
											</div>
										</div>										
									</form>
								</div>
							</div>
						</div>
					</div>
					<div id="myModal" className="modal fade imgmodal" role="dialog">
						<div className="modal-dialog">
							<div className="modal-content">
								<button type="button" className="btn btn-default closeicon" data-dismiss="modal">
									<span aria-hidden="true">&times;</span>
								</button>
								<div className="modal-body">
									<img className="showimage img-responsive" onError={this.addDefaultSrc} style={{ width: '100px', height: '100px' }} src={this.state.urlvalinitial} />
								</div>
							</div>
						</div>
					</div>
				</section>
			</React.Fragment>
		);
		}
	}
}

export default function InjectedCheckoutForm(props) {
	return (
		<ElementsConsumer>
			{({ stripe, elements }) => (
				<CheckoutForm stripe={stripe} elements={elements} ref_code={props.code} type={props.type}/>
			)}
		</ElementsConsumer>
	);
}